module.exports = __webpack_public_path__ + "static/media/CNBC_Economist_Logo_White.c7667d01.svg";